<app-layout>
  <app-voltar route="listagem/precificacao" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          type="select"
          label="Serviço"
          name="FK_SRVC"
          formControlName="FK_SRVC"
          placeholder="Selecione"
          [disabled]="title.includes('Visualizar') ? true : false"
          [requiredInput]="true"
          [selectData]="servicoOptions"
          (ngModelChange)="escolherServico($event)">
        </app-input>

        <app-input
          type="money"
          label="Valor"
          name="VL_SRVC"
          formControlName="VL_SRVC"
          maxLength="8"
          placeholder="0,00"
          [requiredInput]="true"></app-input>

        <app-input
          *ngIf="(tipoCarreta)"
          type="select"
          label="Tipo da Carreta"
          name="FK_TIPO_CRRT"
          formControlName="FK_TIPO_CRRT"
          placeholder="Selecione"
          [disabled]="title.includes('Visualizar') ? true : false"
          [requiredInput]="tipoCarreta"
          [selectData]="tipoCarretaOptions"
          (ngModelChange)="escolherTipoCarreta($event)">
        </app-input>

        <app-input
          *ngIf="(tipoCarga)"
          type="select"
          label="Tipo da Carga"
          name="FK_CRGA"
          formControlName="FK_CRGA"
          placeholder="Selecione"
          [disabled]="title.includes('Visualizar') ? true : false"
          [requiredInput]="tipoCarga"
          [selectData]="tipoCargaOptions"
          (ngModelChange)="escolherTipoCarga($event)"></app-input>

        <app-input
          *ngIf="(quantidadeEixos)"
          type="select"
          label="Quantidade de Eixos"
          name="QT_TOTL_EIXO"
          formControlName="QT_TOTL_EIXO"
          placeholder="Selecione"
          [requiredInput]="quantidadeEixos"
          [selectData]="tipoEixosOptions"
          (ngModelChange)="escolherTipoEixo($event)"></app-input>

        <app-input
          *ngIf="(quantidadeCompartimentos)"
          type="select"
          label="Quantidade de Compartimentos"
          name="QT_CPTM"
          formControlName="QT_CPTM"
          placeholder="Selecione"
          [requiredInput]="quantidadeCompartimentos"
          [selectData]="qtdCompartimentosOptions"
          (ngModelChange)="escolherCompartimento($event)"></app-input>
      </div>
      <app-botao
        *ngIf="!disabledCavalo"
        type="cadastro"
        [text]="isEditing ? 'Editar precificação' : 'Cadastrar precificação'"
        class="botao-cadastro"
        [disabled]="!form.valid && !visivelNoAgendamento"
        (click)="postarDados()"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
